import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 1080.000000 1073.000000"
        enableBackground="new 0 0 1080 1080"
      >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1073.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M4096 10469 c-22 -17 -26 -28 -26 -72 0 -84 -7 -97 -49 -97 -20 0
-62 -11 -94 -24 l-58 -24 -39 26 c-27 17 -40 33 -40 48 0 13 -11 35 -24 50
-20 24 -33 28 -88 32 -35 2 -81 -1 -101 -6 -36 -10 -39 -9 -75 28 -92 92 -235
46 -251 -82 l-6 -53 -160 0 c-176 0 -201 -6 -267 -64 -43 -37 -48 -38 -78 -7
-33 36 -102 65 -168 72 -175 19 -308 -103 -322 -295 l-5 -76 -74 -3 c-41 -2
-78 1 -84 7 -6 6 -10 104 -11 238 -1 161 -5 234 -13 250 -19 31 -75 46 -155
41 -118 -9 -112 9 -116 -366 -2 -174 0 -332 3 -350 3 -17 16 -41 27 -52 20
-19 36 -20 249 -20 l227 0 31 26 c30 25 33 25 56 10 14 -9 53 -23 86 -32 98
-25 200 -6 275 51 58 44 73 23 29 -41 -35 -51 -32 -71 19 -120 132 -126 402
-92 476 60 l22 46 94 0 c86 0 97 2 118 23 13 13 25 29 27 36 3 9 21 2 56 -22
29 -19 70 -38 93 -42 54 -9 130 2 165 25 28 18 29 18 69 -3 38 -20 54 -21 206
-19 146 2 168 5 192 22 34 25 39 25 85 -2 36 -22 46 -23 218 -20 162 3 182 5
201 23 26 24 34 24 81 -3 45 -27 143 -31 211 -9 36 12 48 12 83 1 44 -15 59
-16 251 -12 120 2 128 3 158 28 l31 26 24 -26 c22 -24 31 -26 105 -26 85 0
103 8 136 66 11 18 12 18 22 -7 18 -46 48 -59 132 -59 86 0 116 17 127 71 9
45 21 45 63 2 67 -71 93 -78 280 -78 l165 0 3 -66 c4 -85 26 -110 105 -117
116 -9 202 48 245 163 34 93 34 93 80 55 38 -30 45 -32 103 -28 57 4 65 8 94
41 18 20 38 37 45 37 7 0 28 -13 46 -30 85 -75 251 -78 345 -7 23 18 48 36 55
42 9 6 24 0 51 -21 69 -55 109 -69 203 -68 87 1 119 11 183 58 29 21 29 21 42
1 36 -51 45 -55 135 -55 73 0 92 3 114 21 l26 20 26 -20 c38 -30 174 -30 223
0 l33 20 22 -20 c19 -18 35 -21 110 -21 80 0 89 2 112 25 l26 26 -4 212 c-3
211 -3 212 -31 259 -52 89 -162 127 -269 93 -50 -15 -59 -15 -106 -2 -40 12
-84 15 -199 11 -163 -6 -195 -14 -211 -50 -13 -27 -25 -30 -44 -10 -30 29
-101 57 -161 63 -81 7 -159 -15 -218 -62 -24 -19 -48 -35 -52 -35 -5 0 -27 16
-50 35 -105 90 -292 82 -384 -16 -49 -53 -73 -109 -85 -203 -11 -79 -13 -86
-32 -80 -11 4 -41 6 -68 5 -33 0 -48 3 -48 12 0 7 18 62 40 123 68 186 55 214
-105 214 -91 0 -107 -7 -142 -66 -11 -18 -12 -17 -23 14 -7 18 -20 37 -30 42
-31 16 -187 12 -221 -6 -28 -14 -34 -14 -77 3 -63 24 -180 24 -248 -1 -47 -17
-52 -17 -82 -2 -41 21 -162 22 -208 0 -30 -14 -35 -14 -56 0 -34 24 -158 22
-189 -3 -23 -18 -24 -18 -50 1 -22 17 -38 19 -110 16 -46 -3 -98 -10 -116 -18
-28 -12 -36 -12 -74 6 -64 28 -187 26 -256 -5 l-52 -23 -41 32 c-26 20 -40 40
-40 55 0 47 -30 67 -107 72 -39 3 -83 3 -97 -1 -38 -9 -66 -42 -66 -75 0 -22
-8 -36 -31 -52 l-31 -22 -52 19 c-35 13 -77 19 -132 19 -71 0 -88 -4 -141 -32
-34 -17 -64 -29 -67 -26 -3 4 -6 51 -6 105 0 92 -2 101 -25 123 -22 23 -32 25
-108 25 -70 0 -89 -3 -111 -21z m109 -89 c-3 -5 3 -10 14 -10 12 0 21 -5 21
-11 0 -6 -9 -8 -22 -4 l-23 7 23 -21 c20 -20 22 -31 22 -123 0 -84 -3 -103
-17 -114 -17 -13 -17 -13 1 -14 18 0 18 -16 0 -64 -3 -9 -1 -16 5 -16 9 0 11
-34 10 -120 -1 -83 -6 -120 -14 -120 -6 0 -30 9 -53 20 -39 19 -44 19 -65 5
-24 -17 -67 -20 -67 -5 0 6 6 10 14 10 20 0 74 31 103 59 19 18 22 26 11 32
-9 6 -10 11 -2 19 7 7 8 31 2 71 -4 35 -4 68 1 77 7 13 3 25 -14 45 -13 15
-28 27 -33 27 -5 0 -15 7 -22 15 -15 18 1 21 31 4 28 -15 61 -20 54 -8 -4 5
-10 7 -15 4 -5 -3 -12 0 -16 6 -3 6 -1 14 5 18 6 4 12 42 14 89 1 45 5 82 10
82 4 0 7 5 7 10 0 6 -7 10 -15 10 -8 0 -15 7 -15 15 0 9 10 15 26 15 14 0 23
-4 19 -10z m-791 -15 c-4 -8 -12 -15 -20 -15 -8 0 -14 -7 -14 -15 0 -8 -7 -15
-15 -15 -21 0 -19 30 3 46 24 19 53 18 46 -1z m-1446 -265 c-2 -198 0 -250 10
-260 10 -9 55 -13 143 -14 115 -1 129 -3 129 -18 0 -11 -5 -15 -15 -12 -8 4
-17 -1 -21 -10 -3 -9 -17 -16 -32 -16 -24 0 -25 0 -7 20 16 17 16 20 2 20 -26
0 -47 -11 -47 -26 0 -22 -37 -16 -43 6 -4 16 -13 20 -44 18 l-38 -1 38 -4 c43
-5 50 -23 10 -24 -16 0 -56 -2 -90 -5 l-61 -5 -2 284 c-1 304 -2 294 48 294
l23 1 -3 -248z m1472 230 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15
10 8 0 15 -4 15 -10z m220 -41 c21 -3 25 -8 22 -35 -3 -24 3 -36 23 -52 24
-19 25 -21 8 -31 -10 -6 -14 -11 -9 -11 5 0 1 -9 -9 -20 -15 -16 -17 -36 -16
-125 1 -84 -2 -105 -13 -105 -8 0 -16 -7 -20 -15 -3 -9 0 -15 9 -15 8 0 21
-11 30 -23 16 -25 61 -51 74 -42 5 2 9 -6 9 -20 0 -23 -3 -24 -49 -22 -52 4
-81 17 -36 17 37 0 34 17 -4 25 -21 5 -34 3 -39 -5 -14 -23 -23 51 -22 188 1
103 -2 134 -13 138 -20 8 -26 44 -10 68 12 19 22 55 24 96 1 10 4 11 9 4 4 -7
18 -14 32 -15z m1306 -24 c0 -42 36 -85 65 -78 14 4 19 0 19 -17 0 -16 -4 -20
-16 -16 -8 3 -24 1 -35 -4 -15 -8 -19 -7 -19 4 0 7 -7 27 -15 42 l-16 29 6
-35 c11 -74 13 -167 3 -213 -5 -26 -6 -56 -2 -65 4 -9 6 -22 5 -29 -1 -6 12
-25 29 -42 17 -17 29 -35 25 -40 -3 -5 -1 -12 5 -16 5 -3 10 3 10 14 0 12 5
21 10 21 6 0 10 -11 10 -24 0 -19 -6 -25 -29 -28 -18 -3 -29 0 -28 6 1 6 -4
10 -11 8 -8 -1 -16 7 -19 18 -3 11 -9 17 -14 14 -5 -3 -7 -10 -4 -15 4 -5 2
-9 -3 -9 -5 0 -14 11 -20 25 -10 22 -9 25 13 31 14 3 25 10 25 14 0 12 -37 19
-47 9 -5 -5 -9 39 -10 106 0 63 4 115 9 115 4 0 8 -10 9 -22 1 -22 1 -22 8 2
9 31 4 46 -17 54 -9 3 -24 10 -32 15 -8 5 -23 12 -32 15 -21 6 -13 36 8 36 16
0 73 59 74 75 0 6 -4 4 -9 -3 -7 -11 -10 -10 -15 3 -9 24 -9 23 27 28 17 2 32
5 33 5 0 1 0 -14 0 -33z m-2341 -87 c13 -12 -12 -28 -44 -28 -18 0 -22 4 -17
18 6 16 5 16 -8 0 -7 -10 -23 -18 -35 -18 -29 0 -96 -69 -98 -102 -4 -41 28
-55 125 -54 99 1 117 14 98 69 -6 17 -15 38 -20 46 -6 10 -5 16 2 19 7 2 12
10 12 18 0 12 4 12 24 -1 26 -18 49 -63 45 -91 -1 -11 1 -27 5 -36 5 -10 1
-26 -8 -40 -13 -18 -16 -19 -16 -5 0 11 -8 17 -25 17 -16 0 -25 -6 -25 -15 0
-12 -14 -15 -75 -14 -41 1 -75 4 -75 8 0 3 -11 6 -24 6 -13 0 -22 -3 -20 -7 2
-4 0 -9 -6 -13 -5 -3 -10 -22 -10 -42 0 -39 25 -65 92 -95 21 -9 38 -24 38
-33 0 -16 -26 -21 -32 -6 -1 4 -14 12 -28 16 -24 7 -24 7 -5 -9 28 -22 10 -20
-45 5 -40 18 -51 30 -73 75 -21 46 -22 54 -8 54 14 0 14 2 1 10 -20 12 -23
100 -4 100 11 0 13 10 11 35 -3 19 0 35 4 35 5 0 9 6 9 13 0 16 45 57 63 57 7
0 17 4 23 9 19 20 127 19 149 -1z m397 5 c12 -10 18 -12 18 -4 0 8 11 5 29 -8
36 -26 45 -26 70 0 32 34 61 18 61 -34 0 -23 1 -115 3 -204 3 -117 0 -172 -9
-200 -8 -21 -14 -46 -14 -55 0 -17 -37 -58 -52 -58 -4 0 -8 7 -8 16 0 14 -3
14 -15 4 -8 -7 -14 -20 -13 -29 2 -10 -5 -17 -21 -19 -13 -2 -21 0 -17 6 3 6
0 13 -6 16 -9 3 -7 9 7 17 34 21 92 85 100 108 5 18 2 24 -15 28 -20 5 -21 10
-15 57 3 28 9 99 11 159 4 84 8 107 20 107 8 0 14 5 14 10 0 7 -7 7 -21 -1
-17 -9 -23 -7 -35 9 -20 28 -93 63 -108 51 -6 -6 -26 -19 -43 -29 -39 -23 -79
-100 -77 -150 3 -91 40 -139 125 -165 57 -17 61 -19 43 -32 -17 -12 -19 -12
-22 2 -5 22 -37 14 -35 -9 1 -11 -4 -15 -14 -12 -8 3 -25 6 -37 6 -19 0 -22 4
-19 24 3 13 0 27 -6 30 -6 4 -11 0 -11 -8 0 -28 -26 -16 -47 21 -7 13 -13 31
-13 42 0 11 -5 21 -11 23 -19 6 -17 70 3 90 20 20 19 45 0 41 -8 -2 -9 8 -5
30 8 43 18 53 38 37 8 -7 18 -10 22 -6 3 3 2 6 -4 6 -26 0 -22 33 6 62 28 28
31 29 46 14 22 -21 32 -20 38 4 6 24 15 25 39 3z m1024 6 c3 -6 15 -9 25 -6
10 3 22 1 25 -4 3 -5 -6 -9 -20 -9 -13 0 -26 -5 -28 -10 -2 -6 -17 -12 -33
-14 -16 -2 -31 -9 -33 -17 -5 -15 -31 -39 -43 -39 -4 0 -7 17 -7 38 -1 43 25
67 59 57 11 -4 19 -2 19 4 0 14 27 14 36 0z m514 2 c0 -5 -18 -12 -40 -16 -25
-4 -40 -12 -40 -21 0 -8 -4 -14 -10 -14 -5 0 -10 -11 -10 -25 0 -14 -5 -25
-11 -25 -5 0 -9 10 -7 23 2 13 -2 21 -9 20 -29 -6 -9 14 40 39 53 28 87 35 87
19z m74 -12 c-17 -7 -16 -8 6 -9 14 0 37 -11 52 -25 28 -24 28 -25 34 -188 l6
-164 -29 -6 c-15 -3 -34 0 -42 6 -17 15 -71 9 -92 -9 -14 -13 -18 -13 -29 1
-7 8 -9 16 -4 17 24 4 32 6 65 21 46 21 56 34 60 79 3 30 -2 43 -26 68 -22 23
-25 30 -12 30 20 0 34 25 37 65 3 46 1 55 -12 55 -7 0 -26 14 -41 29 -26 26
-27 30 -11 39 9 5 26 7 37 4 20 -5 20 -6 1 -13z m655 -9 c4 0 11 4 17 9 5 4
24 11 43 15 27 5 32 3 27 -10 -5 -13 -1 -14 25 -9 25 6 36 2 60 -21 32 -30 38
-54 14 -54 -11 0 -15 -8 -12 -25 4 -33 16 -43 13 -11 -2 16 2 26 10 26 10 0
13 -36 13 -160 l1 -160 -25 0 c-18 0 -25 5 -25 19 0 15 -6 19 -32 16 -49 -3
-53 4 -17 35 30 24 33 33 36 89 2 55 -8 81 -20 49 -3 -9 -7 -6 -12 6 -6 13 -3
23 8 31 10 7 17 17 17 24 0 6 5 11 10 11 7 0 7 6 0 19 -8 15 -6 24 7 36 14 14
14 18 2 26 -9 5 -16 3 -20 -8 -4 -13 -10 -11 -31 12 -24 26 -30 28 -78 22 -33
-4 -57 -13 -66 -24 -7 -10 -14 -14 -14 -9 0 5 -7 3 -15 -4 -8 -7 -15 -10 -15
-7 0 13 30 60 46 72 16 12 19 12 22 -1 2 -8 7 -14 11 -14z m1191 15 c0 -12 4
-13 19 -5 46 24 88 3 122 -62 16 -31 18 -56 17 -172 -2 -103 -6 -136 -15 -136
-7 0 -22 -5 -33 -12 -10 -7 -23 -9 -27 -5 -4 5 -1 12 7 17 8 5 12 12 8 15 -7
7 -84 -30 -93 -45 -3 -5 -32 -9 -63 -9 -82 2 -135 45 -112 90 8 14 8 19 -1 17
-6 -2 -14 3 -17 11 -3 10 0 12 12 8 13 -5 15 -1 11 23 -4 23 0 32 16 40 33 18
49 6 40 -28 -5 -16 -8 -45 -6 -63 2 -26 8 -36 29 -43 14 -6 26 -16 26 -23 0
-15 21 -17 36 -4 5 5 26 14 47 21 44 14 67 51 67 107 0 27 -6 42 -20 51 -20
12 -20 13 -1 40 33 46 33 65 4 100 -38 45 -90 56 -138 31 -19 -11 -40 -18 -46
-17 -6 2 -14 -3 -16 -10 -3 -8 1 -10 11 -6 9 3 16 3 16 0 0 -13 -53 -27 -63
-17 -14 14 19 61 43 61 10 0 22 5 25 11 17 27 95 39 95 14z m1162 -2 c7 -6 22
-12 33 -14 11 -2 24 -14 30 -27 5 -12 15 -22 22 -22 7 0 13 -6 13 -14 0 -19
-53 -28 -63 -10 -30 52 -103 89 -119 60 -5 -9 -17 -16 -27 -16 -27 0 -63 -84
-66 -157 -2 -48 2 -73 18 -107 20 -39 27 -45 72 -56 46 -11 54 -10 89 9 38 22
68 19 33 -3 -49 -29 -53 -35 -37 -46 11 -7 6 -9 -20 -6 -19 2 -36 8 -38 15 -2
6 -18 11 -35 11 -24 0 -28 -3 -17 -10 25 -16 3 -23 -29 -9 -36 16 -42 34 -9
23 20 -6 21 -5 9 10 -7 9 -26 16 -41 16 -39 0 -52 43 -49 161 2 123 30 177 84
167 14 -3 25 -1 25 3 0 5 -10 9 -22 9 -23 0 -23 1 2 13 29 15 123 15 142 0z
m476 4 c6 -7 27 -19 46 -27 19 -7 37 -20 40 -29 4 -9 13 -29 22 -44 26 -46 26
-159 1 -217 -12 -27 -27 -50 -32 -50 -6 0 -16 -9 -22 -19 -16 -25 -79 -44
-104 -31 -9 6 -31 7 -47 4 -22 -4 -42 1 -72 17 -37 21 -41 27 -36 52 4 18 2
26 -5 22 -12 -8 -39 13 -39 31 0 7 9 16 20 19 11 3 20 10 20 15 0 5 -7 7 -15
4 -9 -4 -15 0 -15 7 0 11 -3 11 -10 -1 -14 -22 -13 56 2 120 10 42 20 58 60
91 43 36 51 40 75 31 17 -6 21 -11 11 -11 -12 -1 -16 -7 -12 -18 5 -17 5 -17
-6 0 -6 9 -18 17 -25 17 -20 0 -19 -10 3 -26 16 -12 15 -14 -10 -41 -16 -16
-28 -39 -28 -51 0 -12 -4 -22 -10 -22 -5 0 -10 -22 -10 -50 0 -27 5 -50 10
-50 6 0 10 -8 10 -18 0 -10 7 -28 16 -41 16 -23 16 -23 -7 -16 -17 4 -20 3
-10 -3 7 -5 11 -14 8 -19 -6 -9 11 -11 121 -15 20 -1 32 -6 32 -15 0 -8 5 -11
10 -8 6 4 8 11 5 16 -4 5 -2 9 2 9 5 0 17 16 27 35 14 25 25 35 39 33 11 -2
22 3 24 10 3 6 -2 12 -10 12 -11 0 -13 10 -9 48 3 26 9 49 13 50 16 6 9 24
-16 44 -13 10 -30 31 -37 45 -7 15 -34 37 -61 51 -40 19 -46 26 -36 38 14 18
53 18 67 1z m587 -33 c11 -16 11 -20 -2 -30 -14 -10 -14 -11 1 -17 9 -4 16 -2
16 3 0 6 9 10 20 10 20 0 20 -1 3 -27 -15 -23 -18 -49 -17 -176 1 -83 -3 -143
-7 -135 -7 10 -9 10 -9 1 0 -7 -4 -13 -10 -13 -5 0 -10 7 -10 16 0 8 -4 13 -9
9 -16 -9 -24 62 -19 169 3 55 2 112 -1 124 -3 13 -24 36 -45 50 -49 33 -57 52
-22 52 14 0 26 -4 26 -10 0 -5 5 -10 10 -10 6 0 10 6 10 14 0 13 4 13 26 2 14
-8 31 -22 39 -32z m175 35 c0 -6 9 -8 20 -4 12 4 27 1 35 -5 8 -6 19 -9 25 -5
6 4 9 2 8 -4 -2 -5 5 -16 14 -23 11 -8 19 -34 23 -68 6 -52 5 -54 -10 -35 -9
11 -14 28 -12 37 3 11 0 15 -9 11 -17 -6 -18 -2 7 -76 14 -40 17 -63 10 -65
-12 -4 -5 -49 10 -68 9 -11 8 -89 -1 -97 -3 -2 -17 -7 -31 -10 l-27 -7 -4 170
-4 171 -31 29 c-34 32 -87 41 -96 16 -3 -7 -16 -16 -29 -19 -19 -5 -17 -2 11
21 31 24 59 38 84 41 4 1 7 -4 7 -10z m-5310 -13 c0 -8 -4 -18 -10 -21 -5 -3
-10 3 -10 14 0 12 5 21 10 21 6 0 10 -6 10 -14z m2112 -6 c-1 -7 3 -18 9 -26
9 -11 8 -18 -1 -29 -7 -8 -8 -15 -3 -15 18 0 33 -66 27 -114 -6 -37 -4 -45 7
-41 9 3 21 -8 33 -30 l20 -36 13 33 14 32 14 -28 c26 -49 -15 -146 -61 -146
-13 0 -15 9 -12 45 2 25 0 45 -4 45 -5 0 -8 -7 -8 -15 0 -8 -4 -15 -9 -15 -13
0 -21 53 -10 66 6 8 4 18 -8 29 -11 11 -17 31 -16 54 2 33 1 34 -7 11 -8 -20
-9 -14 -6 26 2 42 -1 53 -17 63 -16 10 -18 20 -14 52 3 26 1 39 -6 40 -7 0 -3
4 8 9 25 11 41 6 37 -10z m238 5 c0 -8 4 -15 9 -15 12 0 38 -76 44 -127 6 -52
44 -133 62 -133 8 0 20 9 28 21 19 26 24 17 28 -46 4 -81 0 -105 -16 -105 -8
0 -15 6 -16 13 0 10 -2 10 -6 0 -2 -7 -11 -13 -20 -13 -12 0 -13 8 -8 38 5 29
2 42 -9 52 -10 7 -16 8 -16 2 0 -6 5 -12 12 -14 9 -3 9 -6 0 -12 -15 -9 -35
39 -27 65 4 11 2 19 -4 19 -6 0 -11 10 -11 23 0 12 -7 30 -14 40 -8 10 -12 26
-9 37 4 15 -2 20 -32 26 -39 7 -55 -4 -55 -37 0 -9 -6 -31 -14 -49 l-13 -33
-7 38 c-4 21 -4 41 1 44 18 14 36 58 38 96 3 55 8 69 25 77 24 11 30 9 30 -7z
m870 11 c0 -2 3 -12 6 -21 5 -13 2 -16 -11 -14 -21 5 -30 39 -9 39 8 0 14 -2
14 -4z m1660 -16 c0 -10 -4 -22 -10 -25 -5 -3 -10 -15 -10 -25 0 -10 -5 -20
-11 -22 -7 -2 -5 -9 5 -17 14 -12 16 -10 16 18 0 25 6 34 26 42 37 13 42 4 14
-26 -20 -21 -23 -36 -27 -142 -8 -204 -7 -198 -27 -201 -10 -2 -22 1 -26 7 -9
16 -12 205 -4 316 6 87 7 91 30 93 18 1 24 -3 24 -18z m-5070 -80 c5 0 10 20
12 45 2 30 7 42 14 37 14 -9 17 -53 15 -249 -1 -129 -3 -153 -16 -153 -9 0
-15 9 -15 21 0 15 -5 19 -15 15 -12 -4 -15 6 -15 58 0 42 4 66 12 68 10 4 10
10 1 30 -6 15 -11 68 -10 124 1 55 3 78 5 52 2 -27 7 -48 12 -48z m3709 81
c16 -10 9 -64 -11 -89 -7 -8 -13 -19 -14 -26 -1 -6 -5 -38 -9 -71 -7 -59 -7
-59 -19 -30 -13 30 -13 30 -20 6 -5 -15 -4 -26 3 -31 12 -7 5 -37 -14 -56 -6
-7 -17 -37 -25 -68 -10 -42 -17 -55 -28 -51 -10 3 -12 0 -8 -10 8 -23 -4 -74
-18 -70 -6 3 -19 -7 -30 -21 l-18 -26 22 12 c34 18 38 1 5 -27 -17 -15 -31
-21 -33 -14 -2 7 -8 6 -18 -4 -20 -20 -70 1 -53 22 6 7 22 13 35 13 15 0 24 6
24 15 0 9 6 18 14 21 8 3 17 20 21 37 7 32 7 32 15 7 8 -24 8 -23 9 8 1 17 -2
32 -7 32 -4 0 -12 17 -19 37 -10 33 -9 39 10 57 l22 19 -22 -5 c-17 -5 -25 2
-41 36 -32 65 -53 129 -55 168 -1 20 -6 36 -12 35 -5 -1 -11 9 -13 22 -3 15 0
21 8 16 7 -4 14 1 17 14 7 28 19 26 27 -4 4 -14 17 -49 30 -78 14 -29 27 -66
31 -82 24 -109 53 -114 85 -15 18 55 25 68 35 60 19 -16 26 2 16 38 -12 41 6
112 28 112 9 0 22 -4 30 -9z m-3326 -8 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14
0 19 -2 13 -5z m800 0 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z
m1591 -15 c9 -36 -37 -218 -55 -218 -4 0 -9 19 -13 42 -5 32 -3 45 8 53 9 7
12 21 9 38 -4 20 -1 27 11 27 17 0 22 15 7 24 -12 8 -1 56 14 56 7 0 15 -10
19 -22z m2391 1 c-4 -5 -13 -9 -22 -9 -13 0 -13 3 -3 15 13 15 35 11 25 -6z
m-4612 -69 c8 0 12 -28 12 -92 0 -56 5 -102 13 -115 11 -19 10 -23 -2 -23 -7
0 -17 -8 -20 -17 -7 -17 9 -33 34 -33 11 0 11 3 2 12 -20 20 -14 29 16 22 42
-10 47 -16 26 -31 -16 -12 -17 -15 -4 -23 11 -7 7 -10 -16 -10 -22 0 -41 10
-68 36 -34 33 -40 62 -10 50 9 -4 14 2 14 15 0 18 -4 20 -25 15 -28 -7 -29 -3
-25 74 1 25 6 46 10 48 4 2 6 20 3 40 -3 20 1 51 8 67 l13 30 4 -32 c2 -18 9
-33 15 -33z m1267 45 c0 -8 -7 -15 -16 -15 -14 0 -14 3 -4 15 7 8 14 15 16 15
2 0 4 -7 4 -15z m2880 -145 c0 -47 -23 -71 -39 -41 -6 11 -11 29 -11 41 0 12
5 30 11 41 16 30 39 6 39 -41z m-5052 -6 c-2 -22 -7 -39 -13 -39 -12 0 -19 60
-10 83 10 28 27 -3 23 -44z m1032 4 c-1 -34 -3 -39 -11 -26 -8 15 -3 68 7 68
2 0 4 -19 4 -42z m3560 -3 c0 -16 -35 -47 -43 -38 -4 3 -7 21 -7 38 0 17 3 35
7 38 8 9 43 -22 43 -38z m-2284 8 c-10 -10 -19 5 -10 18 6 11 8 11 12 0 2 -7
1 -15 -2 -18z m-782 8 c14 -5 8 -10 -28 -18 -49 -11 -61 -3 -23 15 26 13 27
13 51 3z m1961 -1 c-3 -5 -13 -10 -21 -10 -8 0 -14 5 -14 10 0 6 9 10 21 10
11 0 17 -4 14 -10z m-1232 -6 c7 -7 -46 -54 -62 -54 -14 0 -14 -9 0 -49 6 -17
15 -31 20 -31 5 0 9 -7 9 -15 0 -8 9 -15 19 -15 11 0 22 -4 26 -9 3 -6 17 -6
34 -1 21 6 31 5 34 -4 9 -24 -9 -36 -59 -41 -29 -3 -44 -1 -35 4 10 7 10 10 1
16 -7 4 -16 2 -20 -5 -12 -20 -28 -3 -22 25 3 18 -2 32 -17 46 -25 24 -26 18
-5 -22 17 -33 14 -45 -10 -36 -9 4 -13 13 -10 22 4 10 0 15 -11 15 -13 0 -15
5 -9 23 5 12 8 36 9 54 0 41 29 76 55 68 12 -4 20 -2 20 4 0 12 23 15 33 5z
m1157 -8 c-36 -12 -70 -10 -70 5 0 5 24 9 53 8 l52 0 -35 -13z m-1978 -26
c-10 -83 -7 -102 20 -121 18 -13 24 -25 21 -39 -7 -26 -28 -25 -46 1 -11 14
-16 17 -19 7 -7 -19 -44 16 -52 48 -8 32 1 49 19 34 10 -8 14 -4 19 16 8 30
-1 45 -13 25 -7 -11 -9 -11 -14 0 -6 18 33 61 53 57 10 -3 14 -12 12 -28z
m3278 -80 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4
10 -10z m-959 -70 c12 -39 6 -76 -10 -66 -5 3 -14 26 -20 51 -19 75 8 88 30
15z m454 35 c6 0 11 -15 13 -32 2 -18 -1 -33 -7 -33 -15 0 -23 18 -9 22 15 5
1 28 -18 28 -9 0 -14 -7 -12 -17 2 -11 -3 -18 -12 -18 -9 0 -14 7 -12 20 5 28
22 46 36 38 6 -4 16 -8 21 -8z m491 -12 c-10 -10 -19 5 -10 18 6 11 8 11 12 0
2 -7 1 -15 -2 -18z m-5026 7 c0 -5 -7 -10 -15 -10 -8 0 -15 -6 -15 -14 0 -10
-9 -14 -27 -13 -18 1 -27 -3 -25 -10 3 -19 -25 -16 -32 4 -9 23 7 36 49 38 20
1 39 5 42 9 10 9 23 7 23 -4z m410 -10 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15
10 0 6 7 10 15 10 8 0 15 -4 15 -10z m3530 -40 c0 -5 -12 -10 -26 -10 -14 0
-23 4 -19 10 3 6 15 10 26 10 10 0 19 -4 19 -10z m-3712 -139 c24 -10 30 -16
21 -22 -7 -4 -19 -3 -26 3 -7 6 -22 8 -33 5 -12 -3 -20 0 -20 7 0 15 11 28 19
23 3 -2 21 -9 39 -16z m97 -21 c-3 -5 -15 -10 -26 -10 -10 0 -19 5 -19 10 0 6
12 10 26 10 14 0 23 -4 19 -10z"
          />
          <path
            d="M1920 9820 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
          />
          <path
            d="M1980 9789 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
          />
          <path d="M2385 9891 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z" />
          <path d="M2910 10140 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
          <path
            d="M2870 9866 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"
          />
          <path
            d="M3140 9660 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
          />
          <path d="M4675 10111 c-6 -11 9 -23 19 -14 9 9 7 23 -3 23 -6 0 -12 -4 -16 -9z" />
          <path
            d="M4689 10068 c-6 -20 -5 -96 1 -108 7 -13 10 -13 15 3 4 9 2 24 -5 32
-9 10 -9 15 -1 15 14 0 15 47 1 55 -5 3 -10 5 -11 3z"
          />
          <path
            d="M4677 9836 c-5 -14 10 -36 25 -36 13 0 9 27 -6 39 -10 9 -15 8 -19
-3z"
          />
          <path
            d="M5470 9836 c0 -8 -3 -23 -7 -33 -6 -16 -5 -16 10 -4 18 15 23 51 7
51 -5 0 -10 -6 -10 -14z"
          />
          <path d="M6606 9944 c-9 -22 -8 -24 9 -18 8 4 15 12 15 20 0 19 -16 18 -24 -2z" />
          <path
            d="M6375 9800 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"
          />
          <path
            d="M7440 10120 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"
          />
          <path
            d="M7436 10074 c-4 -9 -4 -19 -1 -22 2 -3 7 3 11 12 4 9 4 19 1 22 -2 3
-7 -3 -11 -12z"
          />
          <path d="M7426 10015 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z" />
          <path d="M7431 9914 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M8140 10146 c0 -14 29 -30 38 -21 3 3 0 5 -6 5 -7 0 -12 7 -12 15 0
8 -4 15 -10 15 -5 0 -10 -6 -10 -14z"
          />
          <path
            d="M7928 10119 c-10 -5 -18 -14 -18 -19 0 -17 15 -11 28 10 14 23 13 23
-10 9z"
          />
          <path
            d="M7894 10036 c-3 -8 -1 -23 5 -33 9 -15 10 -13 11 15 0 34 -7 42 -16
18z"
          />
          <path
            d="M8060 9790 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
          />
          <path
            d="M8640 10145 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8
0 -15 -7 -15 -15z"
          />
          <path
            d="M8680 10075 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0
-10 -7 -10 -15z"
          />
          <path
            d="M5660 10123 c0 -28 3 -34 10 -23 13 20 13 47 0 55 -6 4 -10 -9 -10
-32z"
          />
          <path
            d="M5790 9850 c-11 -7 -12 -12 -4 -20 8 -8 13 -6 17 9 3 12 4 21 4 21
-1 0 -9 -5 -17 -10z"
          />
          <path d="M5911 10104 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M6072 9830 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
          <path d="M8410 9817 c4 -41 5 -41 8 -8 2 18 0 37 -5 42 -5 5 -6 -11 -3 -34z" />
          <path d="M6821 10074 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M6931 9798 c-1 -16 4 -28 9 -28 12 0 12 8 0 35 -8 18 -9 17 -9 -7z" />
          <path
            d="M5210 9146 c-171 -100 -313 -183 -370 -216 -36 -20 -139 -80 -230
-132 -91 -52 -172 -97 -180 -101 -8 -4 -35 -21 -60 -37 -25 -16 -54 -34 -66
-39 -12 -5 -72 -40 -135 -78 -63 -37 -126 -73 -141 -80 -16 -7 -48 -26 -72
-43 -25 -16 -47 -30 -50 -30 -3 0 -49 -26 -103 -59 -54 -32 -136 -80 -183
-105 -135 -76 -204 -116 -218 -130 -10 -10 -13 -206 -12 -997 0 -541 0 -1036
0 -1099 l0 -115 58 -35 c31 -19 80 -46 107 -60 28 -14 75 -41 105 -60 30 -20
84 -51 120 -69 36 -19 79 -44 95 -56 17 -12 59 -37 95 -56 101 -54 424 -242
430 -249 3 -4 16 -11 30 -15 14 -4 39 -18 56 -31 17 -13 33 -24 36 -24 3 0 53
-28 111 -62 58 -35 154 -90 212 -123 59 -33 146 -84 193 -114 48 -29 112 -66
143 -82 31 -15 59 -35 63 -44 3 -9 6 -472 6 -1029 0 -980 -1 -1013 -19 -1032
-10 -10 -67 -46 -126 -79 -58 -33 -145 -84 -193 -113 -48 -29 -116 -68 -152
-87 -36 -19 -72 -40 -80 -45 -21 -15 -311 -180 -337 -194 -13 -6 -23 -14 -23
-18 0 -5 -4 -8 -9 -8 -10 0 -367 -204 -448 -256 -29 -19 -56 -34 -61 -34 -4 0
-28 -13 -53 -28 -24 -16 -69 -42 -99 -59 -30 -17 -82 -47 -114 -67 -33 -20
-72 -36 -88 -36 -15 0 -62 20 -104 45 -41 25 -77 45 -79 45 -4 0 -81 45 -363
211 -45 27 -87 49 -92 49 -6 0 -10 4 -10 9 0 5 -8 11 -17 14 -10 3 -45 22 -78
41 -33 19 -87 50 -120 67 -33 17 -78 44 -100 58 -22 15 -87 54 -145 87 -58 32
-113 63 -122 69 -112 66 -254 148 -311 180 -40 23 -94 53 -120 68 -72 41 -100
59 -124 81 l-23 19 0 1028 0 1027 31 26 c17 14 34 26 39 26 4 0 56 30 115 66
59 36 115 68 124 72 9 3 35 18 58 34 23 15 44 28 47 28 4 0 39 20 79 44 75 46
373 218 466 269 29 16 89 51 133 78 44 27 81 49 84 49 2 0 49 27 105 60 55 33
102 60 104 60 17 0 205 125 202 133 -2 7 -20 21 -40 32 l-37 20 -77 -40 c-42
-22 -116 -64 -165 -92 -49 -29 -91 -53 -93 -53 -2 0 -40 -22 -84 -50 -44 -28
-83 -50 -85 -50 -2 0 -35 -19 -72 -42 -38 -23 -107 -63 -154 -88 -47 -26 -111
-62 -143 -81 -222 -131 -276 -163 -378 -220 -62 -35 -121 -68 -130 -74 -9 -5
-48 -27 -85 -49 -38 -21 -86 -49 -107 -63 l-37 -23 2 -1102 3 -1101 114 -68
c62 -38 116 -69 118 -69 2 0 41 -22 86 -49 145 -86 281 -165 317 -184 50 -27
282 -162 365 -212 39 -24 102 -60 140 -80 39 -21 82 -46 97 -56 14 -11 29 -19
31 -19 3 0 63 -34 132 -75 69 -42 133 -79 143 -83 20 -8 84 -45 198 -113 45
-27 87 -49 93 -49 6 0 11 -4 11 -9 0 -5 13 -14 29 -21 32 -13 49 -7 147 56 29
19 56 34 59 34 4 0 19 8 33 18 15 11 52 32 82 49 101 55 345 196 360 208 8 7
56 34 105 60 50 26 97 53 105 60 8 6 49 30 91 53 42 22 102 57 132 76 31 20
58 36 61 36 3 0 50 26 103 58 54 32 145 85 203 117 58 32 116 66 130 75 14 9
61 36 105 60 44 23 87 48 95 54 8 7 36 25 62 39 26 15 50 31 53 37 3 5 5 468
5 1029 0 562 3 1039 6 1062 8 45 -3 37 191 152 62 37 116 67 120 67 5 0 31 15
58 33 28 19 196 117 375 219 179 102 350 202 380 222 30 20 59 36 64 36 5 0
69 35 140 78 359 215 445 262 481 262 15 0 50 -13 77 -30 26 -16 51 -30 54
-30 4 0 54 -29 113 -63 210 -126 471 -277 478 -277 3 0 34 -18 69 -40 35 -22
65 -40 67 -40 2 0 127 -72 278 -159 151 -88 343 -199 427 -248 84 -48 171
-100 193 -116 l39 -27 0 -1035 0 -1034 -42 -29 c-24 -16 -65 -41 -93 -56 -27
-14 -72 -40 -100 -56 -27 -17 -57 -33 -65 -37 -8 -3 -26 -14 -40 -23 -14 -9
-50 -31 -80 -47 -117 -65 -157 -88 -200 -118 -25 -17 -61 -37 -80 -45 -19 -7
-47 -22 -62 -32 -14 -10 -29 -18 -33 -18 -3 0 -21 -11 -38 -24 -18 -13 -61
-39 -97 -58 -36 -20 -119 -67 -185 -105 -123 -72 -472 -273 -605 -350 -41 -24
-79 -43 -85 -43 -5 0 -35 15 -66 33 -71 41 -256 149 -278 162 -9 6 -52 30 -96
55 -44 24 -92 51 -106 60 -14 8 -63 37 -110 63 -46 26 -102 59 -124 72 -36 22
-128 75 -245 142 -25 14 -97 56 -160 93 -63 37 -135 79 -160 92 -25 14 -71 40
-103 59 -160 93 -169 94 -166 32 1 -21 6 -46 11 -55 4 -9 52 -40 105 -69 54
-29 136 -75 183 -104 47 -28 110 -65 140 -82 30 -17 108 -62 173 -99 64 -38
136 -80 160 -93 23 -13 80 -46 127 -74 47 -28 110 -64 139 -80 30 -17 90 -51
132 -76 261 -155 430 -250 445 -251 6 0 74 37 150 82 76 44 168 97 204 116 36
19 104 58 152 88 48 30 90 54 92 54 2 0 33 17 67 38 35 21 100 58 144 82 44
23 103 57 130 75 68 45 245 145 254 145 5 0 19 8 32 19 26 20 47 33 204 121
55 31 141 80 190 110 50 29 119 69 155 88 36 19 80 46 98 60 l32 24 0 1098 c0
866 -3 1100 -12 1107 -7 6 -38 24 -68 40 -89 49 -202 115 -240 139 -19 12 -62
36 -95 54 -33 18 -99 57 -146 86 -47 30 -89 54 -92 54 -3 0 -61 33 -129 73
-148 88 -195 115 -273 158 -33 17 -67 38 -76 45 -8 8 -18 14 -22 14 -3 0 -30
14 -59 31 -29 18 -66 39 -83 49 -16 9 -106 61 -200 115 -336 195 -390 225
-408 225 -17 0 -137 -61 -166 -84 -7 -6 -42 -27 -77 -46 -116 -64 -199 -112
-251 -146 -29 -19 -55 -34 -58 -34 -3 0 -35 -18 -71 -40 -36 -22 -68 -40 -70
-40 -6 0 -157 -86 -229 -130 -83 -52 -290 -170 -297 -170 -3 0 -64 -36 -137
-80 -72 -44 -133 -80 -136 -80 -2 0 -51 -28 -107 -61 -98 -59 -121 -73 -203
-119 -20 -11 -43 -20 -51 -20 -16 0 -103 46 -214 113 -36 22 -99 59 -140 82
-125 70 -154 87 -181 106 -15 10 -37 23 -50 29 -13 5 -33 16 -44 22 -26 17
-81 50 -135 80 -49 28 -227 129 -330 188 -142 81 -187 108 -243 143 -31 20
-59 37 -61 37 -3 0 -43 23 -91 50 -48 28 -90 50 -95 50 -4 0 -13 7 -20 15 -7
9 -43 30 -78 47 -36 18 -81 45 -99 61 l-33 29 0 1017 c0 559 4 1021 8 1026 10
16 157 107 232 145 36 19 88 48 115 66 28 18 78 47 112 66 34 18 123 69 197
113 75 44 178 103 229 132 50 29 112 65 137 80 25 15 74 44 110 63 36 20 83
47 105 59 41 24 370 214 487 282 74 43 81 43 151 -5 21 -14 57 -36 80 -48 23
-11 123 -68 222 -126 99 -58 227 -132 285 -165 58 -32 110 -63 117 -68 6 -6
35 -23 65 -38 29 -16 109 -61 178 -101 175 -102 224 -131 284 -165 30 -16 93
-52 141 -80 48 -27 116 -66 150 -85 34 -19 69 -40 76 -46 8 -6 33 -21 56 -33
79 -40 73 41 73 -973 0 -500 3 -908 7 -908 3 0 26 11 50 25 l43 26 -2 926 -3
927 -50 29 c-44 26 -164 96 -375 218 -36 20 -103 59 -150 85 -47 26 -108 63
-137 81 -29 18 -54 33 -57 33 -3 0 -27 13 -53 28 -27 16 -97 57 -158 92 -60
35 -157 91 -215 125 -97 58 -214 125 -400 230 -41 24 -122 70 -180 104 -58 34
-116 61 -130 60 -14 0 -50 -15 -80 -33z"
          />
          <path
            d="M5270 8852 c-63 -32 -505 -286 -510 -293 -3 -3 -27 -18 -55 -33 -27
-15 -79 -45 -115 -66 -36 -21 -96 -56 -135 -77 -38 -22 -121 -69 -184 -106
-62 -37 -114 -67 -116 -67 -1 0 -35 -19 -76 -43 -41 -24 -89 -52 -108 -63 -18
-10 -68 -39 -110 -64 -42 -25 -92 -54 -112 -64 -19 -10 -44 -25 -54 -33 -19
-13 -20 -41 -23 -947 -3 -815 -1 -935 11 -947 9 -8 37 -27 64 -42 26 -15 97
-57 157 -93 60 -35 110 -64 112 -64 2 0 33 -18 69 -40 36 -22 68 -40 70 -40 3
0 38 -20 78 -44 39 -24 97 -56 127 -71 30 -15 57 -31 58 -36 2 -5 7 -9 12 -9
7 0 139 -77 190 -110 8 -6 24 -14 36 -19 12 -5 47 -26 79 -46 32 -21 83 -51
114 -67 31 -16 70 -37 86 -47 100 -60 344 -201 359 -207 10 -4 38 7 74 29 31
19 77 46 102 59 92 50 196 112 237 140 23 15 61 37 85 48 24 11 77 41 118 66
41 25 93 56 115 68 22 13 66 38 99 57 32 19 86 49 120 67 33 18 88 51 121 72
33 21 83 50 110 65 28 15 73 40 100 55 57 31 298 188 333 216 l22 19 1 923 c0
724 -3 927 -12 939 -7 8 -42 30 -78 49 -36 19 -93 51 -126 71 -33 19 -85 49
-115 66 -30 16 -66 38 -80 47 -22 15 -116 69 -290 168 -25 14 -126 72 -225
130 -99 58 -203 117 -231 132 -28 15 -64 35 -80 46 -49 32 -68 44 -94 56 -14
7 -47 27 -75 44 -55 34 -212 124 -218 124 -1 0 -18 -8 -37 -18z m-233 -1049
c10 -13 13 -162 13 -675 l0 -658 58 -1 c31 0 215 -1 409 -2 245 -1 355 -5 363
-13 16 -16 18 -270 3 -285 -8 -8 -178 -12 -578 -13 -516 -1 -568 0 -579 16 -8
11 -11 53 -9 130 1 62 2 427 3 811 l0 698 23 8 c12 5 80 7 152 5 109 -3 132
-6 142 -21z"
          />
          <path
            d="M3335 5657 c-60 -35 -139 -81 -175 -103 -37 -22 -74 -43 -84 -47 -10
-4 -93 -52 -185 -106 -186 -109 -385 -225 -440 -256 -20 -12 -67 -39 -106 -60
-38 -21 -92 -53 -120 -71 -46 -29 -130 -77 -275 -157 -30 -16 -67 -39 -82 -49
l-28 -19 0 -928 c0 -731 3 -931 13 -939 6 -5 64 -39 127 -75 63 -35 144 -81
180 -102 104 -61 182 -106 302 -174 62 -35 120 -69 128 -76 8 -7 56 -34 105
-60 50 -27 107 -59 127 -71 20 -13 128 -76 240 -140 112 -64 215 -125 229
-135 15 -10 30 -19 33 -19 2 0 33 -16 67 -36 l62 -37 71 38 c105 57 132 72
173 98 21 14 67 41 103 61 36 20 79 45 95 55 17 10 68 40 115 66 47 27 148 85
225 130 217 126 325 189 380 220 272 153 408 234 432 255 l23 20 0 923 c0 867
-1 925 -17 939 -10 9 -43 29 -73 46 -61 33 -316 180 -480 277 -58 34 -112 64
-120 68 -8 4 -31 17 -50 29 -19 12 -53 31 -75 43 -22 12 -56 31 -75 42 -104
59 -146 84 -160 93 -8 5 -91 54 -184 107 -93 54 -181 105 -195 113 -84 49
-180 100 -187 100 -5 0 -58 -28 -119 -63z m269 -986 c43 -11 120 -41 171 -65
80 -38 106 -57 187 -137 106 -107 159 -196 205 -346 24 -81 27 -102 27 -258 0
-147 -3 -182 -22 -255 -76 -280 -286 -485 -571 -556 -93 -23 -109 -24 -481
-24 -287 0 -389 3 -398 12 -9 9 -12 205 -12 819 l0 808 21 15 c18 12 78 14
408 11 351 -3 393 -5 465 -24z"
          />
          <path
            d="M3055 4358 c-3 -7 -6 -235 -7 -505 -3 -403 -1 -494 10 -498 8 -3 92
-5 187 -5 273 0 370 28 487 140 87 84 146 259 134 402 -12 155 -50 249 -135
337 -116 120 -187 141 -474 141 -149 0 -199 -3 -202 -12z"
          />
          <path
            d="M7080 5595 c-30 -19 -71 -42 -90 -51 -19 -10 -66 -37 -105 -59 -184
-109 -384 -225 -390 -225 -3 0 -26 -15 -52 -34 -27 -18 -87 -54 -136 -79 -48
-26 -104 -58 -125 -72 -20 -14 -40 -25 -44 -25 -4 0 -38 -20 -75 -44 -37 -24
-92 -56 -121 -72 -84 -46 -123 -67 -177 -98 -27 -16 -70 -40 -95 -54 -25 -13
-63 -37 -85 -51 l-40 -27 -3 -924 c-2 -848 -1 -925 14 -942 10 -10 21 -18 26
-18 5 0 28 -13 51 -28 23 -16 78 -48 122 -72 44 -24 123 -69 175 -100 52 -32
113 -67 135 -79 22 -12 76 -44 120 -71 44 -27 89 -53 101 -59 11 -5 81 -44
155 -86 74 -43 154 -89 179 -103 24 -14 84 -49 133 -78 49 -30 91 -54 92 -54
1 0 44 -25 95 -55 105 -64 204 -115 221 -115 16 0 78 30 124 60 22 15 72 44
110 65 39 21 149 84 245 140 96 57 198 115 225 130 28 15 61 36 75 45 14 10
52 32 85 49 33 18 89 50 125 71 36 21 87 51 113 65 27 14 77 44 113 65 35 22
67 40 70 40 2 0 28 16 57 35 28 19 56 35 60 35 9 0 100 53 167 98 l35 23 5
914 c3 503 3 924 0 936 -5 22 -20 33 -165 116 -38 22 -124 72 -190 110 -117
68 -231 134 -560 323 -88 50 -200 116 -250 145 -272 160 -429 245 -448 244
-12 0 -47 -16 -77 -34z m-801 -1004 c10 -10 38 -79 61 -152 23 -74 91 -285
152 -469 60 -184 120 -366 132 -405 14 -43 28 -70 37 -70 12 0 111 270 174
475 8 25 37 113 66 195 28 83 55 164 60 180 19 70 80 239 90 252 8 9 39 13
105 13 111 0 114 -2 150 -106 13 -38 37 -107 53 -154 16 -47 58 -164 92 -260
34 -96 94 -271 133 -389 40 -118 77 -216 83 -218 7 -3 24 36 43 99 17 57 35
112 40 123 5 11 13 36 19 55 19 67 133 426 178 560 24 74 51 160 59 190 28
104 20 100 209 100 148 0 165 -2 174 -18 7 -14 -2 -50 -35 -143 -24 -68 -60
-169 -80 -224 -19 -55 -57 -158 -84 -230 -27 -71 -58 -159 -70 -195 -11 -36
-24 -74 -29 -85 -6 -11 -25 -65 -45 -120 -19 -55 -46 -131 -61 -170 -15 -38
-31 -86 -36 -105 -6 -19 -14 -44 -19 -55 -9 -20 -70 -182 -97 -260 -8 -22 -19
-46 -25 -52 -13 -16 -239 -18 -267 -4 -10 6 -37 58 -60 118 -64 162 -92 234
-108 273 -8 19 -19 44 -23 55 -14 35 -57 157 -81 230 -12 39 -28 86 -35 105
-7 19 -23 69 -36 110 -33 109 -36 107 -93 -70 -21 -63 -42 -123 -47 -133 -5
-10 -18 -53 -29 -95 -11 -42 -23 -86 -28 -97 -44 -102 -110 -267 -137 -343
-61 -168 -53 -162 -209 -162 -148 0 -134 -11 -196 160 -22 63 -60 169 -84 235
-24 66 -58 158 -75 205 -55 147 -111 301 -150 410 -20 58 -51 140 -69 184 -17
43 -47 124 -65 180 -19 55 -48 139 -65 185 -24 64 -29 87 -20 97 9 11 48 14
170 14 142 0 161 -2 178 -19z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
